import { render, staticRenderFns } from "./RuleDescriptionForm.vue?vue&type=template&id=eb4d1b82&"
import script from "./RuleDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./RuleDescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./RuleDescriptionForm.vue?vue&type=style&index=0&id=eb4d1b82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports